// extracted by mini-css-extract-plugin
module.exports = {"showMore":"RecentActivity_showMore__29dV3","auditLogsModal":"RecentActivity_auditLogsModal__3Zip7"};